<div>
  <div class="row">
    <div class="col-12">
      <div class="offcanvas-header border-bottom">
        <h5 class="offcanvas-title" id="offcanvasRightLabel">Booking Details</h5>
        <div class="bookiid"> Booking ID:BK-{{selectedBooking?.bookingId}}</div>
        <span class="bookingstatuspending" *ngIf="selectedBooking?.bookingStatus=='Pending'"><img
            src="/assets/bookingIcon/Pending.svg" width="14" height="14"> Pending</span>
        <span class="bookingstatusupcoming" *ngIf="selectedBooking?.bookingStatus=='Confirmed'"><img
            src="/assets/bookingIcon/upcoming.svg" width="17" height="17"> Upcoming</span>
        <span *ngIf="selectedBooking?.bookingStatus=='Completed'" class="bookingstatus"><img
            src="/assets/bookingIcon/Success.svg" width="15" height="15">
          Completed</span>
        <span class="bookingstatuscanceled" *ngIf="selectedBooking?.bookingStatus=='Cancelled'"><img
            src="/assets/bookingIcon/Rejected.svg" width="17" height="17"> Canceled</span>


        <button #closeBtn type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
          (click)="closeBookingOffCanava()"></button>
      </div>
    </div>
  </div>
  <div class="offcanvas-body" style="overflow-y: auto; height: calc(100vh - 6vh); padding-inline: 1rem;">
    <div *ngIf="!reasonvisiable" style="padding-inline: 2rem; height: 100%;">

      <div class="" style="    height: 60px;
              display: flex;
             align-items: center;
             width: 100%;">
        <div style="height: 100%; width: 100%; ">

          <div class="tab-container">
            <input type="radio" name="tab" id="tab1" checked hidden>
            <label (click)="tourturns()" for="tab1" class="tab">
              <img src="/assets/bookingIcon/tourdetails.png" width="17" height="17">
              <span>Tour Details</span>
            </label>

            <input type="radio" name="tab" id="tab2" hidden>
            <label (click)="messageturns(selectedBooking)" for="tab2" class="tab">
              <img src="/assets/bookingIcon/message.png" width="17" height="17">
              <span>Message</span>
            </label>

            <input type="radio" name="tab" id="tab3" hidden>
            <label (click)="paymentturns()" for="tab3" class="tab">
              <img src="/assets/bookingIcon/dollars.png" width="17" height="17">
              <span>Payment Details</span>
            </label>
          </div>

        </div>
      </div>
      <div *ngIf="toursection" style=" height: calc(100% - 60px);">
        <div class="TourWrapper">
          <div class="">
            <div class="col-12 d-flex justify-content-between guide-info">
              <div class="guide-detail">
                <img [src]="selectedBooking?.touristProfilePhotoUrl" width="30" height="30" />
                <h5 id="guidenames"> {{selectedBooking?.touristName}}</h5>
              </div>
              <div class="tour">
                <span><img src="/assets/userIcon/tourist.png" class="me-1"> Tourist</span>
              </div>
            </div>
          </div>
          <p id="assigendguide"> Assigned Guide </p>
          <div class="" style="width: 99%;">
            <div class="col-12 d-flex justify-content-between Assigned-info">
              <div class="guide-detail">
                <img [src]="selectedBooking?.tourGuideProfilePhotoUrl" width="30" height="30" />
                <h5 id="guidenames">{{selectedBooking?.guideName}}</h5>
              </div>
              <div class="Guide">
                <span><img src="/assets/bookingIcon/tourguide.png" class="me-1">Guide</span>
              </div>
            </div>
          </div>

          <div class="">
            <div style="width: 99%;">
              <div class="card p-4 tour-info-card tourcard">
                <div class="d-flex align-items-start ">
                  <img src="/assets/bookingIcon/calender.png" width="20" height="20" class="me-3 mt-1">
                  <div>
                    <small class="text-muted">Tour Dates</small>
                    <div class="fw-semibold">{{selectedBooking?.tourStartDate| customDatePipe}} - {{selectedBooking?.tourEndDate| customDatePipe}}</div>
                  </div>
                </div>

                
<div class="d-flex align-items-start">
  <img src="/assets/bookingIcon/clock.png" width="20" height="20" class="me-3 mt-1">
  <div>
    <small class="text-muted">Duration</small>
    <div class="fw-semibold" *ngIf="selectedBooking">{{ selectedBooking.tourStartDate | tripDuration: selectedBooking.tourEndDate }}</div>
  </div>
</div>

                <div class="d-flex align-items-start">
                  <img src="/assets/bookingIcon/pepole.png" width="20" height="20" class="me-3 mt-1">
                  <div>
                    <small class="text-muted">Total Travelers</small>
                    <div class="fw-semibold">{{selectedBooking?.totalTraveller}} Travelers</div>
                  </div>
                </div>
              </div>



            </div>

          </div>
          <hr>
          <div class="" style="width: 99%;">
            <div class="col-12">
              <div class="card p-4 tour-info-card tour-deails-card ">
                <div class="d-flex align-items-start ">
                  <img src="/assets/bookingIcon/location.png" width="20" height="20" class="me-3 mt-1">
                  <div>
                    <small class="text-muted">Pickup point</small>
                    <div class="fw-semibold">{{selectedBooking?.pickupLocation}} </div>
                  </div>
                </div>

        <div class="d-flex align-items-start">
  <img src="/assets/bookingIcon/calender.png" width="20" height="20" class="me-3 mt-1">
  <div>
    <small class="text-muted">Scheduled Time</small>
    <div class="fw-semibold">
      <ng-container *ngIf="getFirstPickupTime() as pickupTime; else notSpecified">
        {{ formatPickupTime(pickupTime) }},
        {{ selectedBooking?.tourStartDate | customDatePipe }}
      </ng-container>
      <ng-template #notSpecified>Not specified</ng-template>
    </div>
  </div>
</div>

                <!-- <div class="d-flex align-items-start">
                  <img src="/assets/bookingIcon/call.png" width="20" height="20" class="me-3 mt-1">
                  <div>
                    <small class="text-muted">Tourist Contact</small>
                    <div class="fw-semibold">{{selectedBooking?.phoneNumber}}</div>
                  </div>
                </div> -->
              </div>

            </div>

          </div>


          <div class="ReviewWrapper"  *ngIf="selectedBooking?.bookingStatus=='Completed'">
            <div class="d-flex align-items-center"><img src="/assets/bookingIcon/smallstar.svg"> <span style="color: #6D6D6D;font-weight: 500; margin-left: 1rem;">Rate TourGuide</span></div>
           <div class="d-flex gap-2 ms-4">
<span style="    display: contents;">
<span style="font-size: larger;font-weight: 500;">{{selectedBooking?.rating}}</span><img src="/assets/bookingIcon/fullStar.svg"> 
</span>


</div>
            <div *ngIf="selectedBooking?.review" class="review-section">
              <p style="font-weight: 500;">Review</p>
              <p style="padding: 10px; background-color: #F0F8FF; color: #09A2F7; border-radius: 8px;">{{selectedBooking?.review}}</p>
            </div>
          </div>

          <hr style="border-top: 1px dashed #000;">

          <div class=" ammountdetai">
            <div class="col-3">


              <div class="cardammount">
                <div class="">
                  <span class="BookingSpan">
                    <p> <img src="/assets/bookingIcon/dollar1.png"></p>
                    <p style="color: #309EAE; font-size: small;"> <strong>Total Booking Amount </strong> </p>
                  </span>

           <p style="color: #309EAE; "> <strong> ${{selectedBooking?.totalPrice}}</strong> </p>

                </div>
              </div>

            </div>
            <div class="col-3">


              <div class="cardammount">
                <div>
                  <span class="BookingSpan">
                    <p> <img src="/assets/bookingIcon/dollar1.png"></p>
                    <p style="color: #309EAE; font-size: small;"> <strong>Guide Earnings </strong> </p>
                  </span>

                    <span class="CommingSoon"> Coming Soon </span>

                </div>
              </div>


            </div>
            <div class="col-3">


              <div class="Companycardammount">
                <div class="">
                  <span class="BookingSpan">
                    <p> <img src="/assets/bookingIcon/White$.svg"></p>
                    <p style="color: #FFFFFF; font-size: small;"> <strong>Company Commission </strong> </p>
                  </span>

                 <span class="CommingSoon"> Coming Soon </span>

                </div>
              </div>


            </div>

          </div>
        </div>
        <div class="cancelWrap"
          *ngIf="selectedBooking?.bookingStatus!='Completed' &&selectedBooking?.bookingStatus!='Cancelled'">
          <div class="col-12 big-div">
            <div class="row px-3">
              <div class="col-12 d-flex justify-content-center align-items-center pointer cancel-booking"
                style="height: 40px;">
                <p class="mb-0" (click)="reasoncancelgo()">Cancel Booking</p>
              </div>
            </div>
          </div>
        </div>





      </div>
      <div *ngIf="messagesection">


        <div *ngIf="chatHistory.length === 0" class="text-center text-muted my-5">
          <p>No chats available</p>
        </div>
        <div class="d-flex flex-column" *ngFor="let chat of chatHistory">

          <div class="d-flex justify-content-end align-items-end mb-2"
            *ngIf="chat.senderId === SelectedtourGuideUserId">
            <div class="message-box d-flex flex-column justify-content-center me-2">
              <p class="mb-2">{{ chat.message }}</p>
              <div class="time text-end">
                <p class="mb-0">
                  <small>{{ chat.sentAt | date:'shortTime' }}</small>
                  <img
                    [src]="chat.isRead ? '/assets/bookingIcon/ic-chat-seen.svg' : '/assets/bookingIcon/ic-chat-un-seen.svg'">
                </p>
              </div>
            </div>
            <div class="guide-message">
              <img [src]="selectedBooking?.tourGuideProfilePhotoUrl || 'assets/userIcon/user.png'"
                class="rounded-circle" width="40" height="40" />
              <img src="/assets/bookingIcon/boldGuide.png" width="25" height="25" />
            </div>
          </div>

          <div class="d-flex justify-content-start align-items-end mb-2"
            *ngIf="chat.senderId === SelectededtouristUserId">
            <div class="guide-message me-2" id="guide-msg">
              <img [src]="selectedBooking?.touristProfilePhotoUrl || 'assets/bookingIcon/touristUser.jpg'"
                class="rounded-circle" width="40" height="40" />
              <img src="/assets/bookingIcon/tourmsg.png" width="25" height="25" />
            </div>
            <div class="message-box d-flex flex-column justify-content-center" id="tourist-msg">
              <p class="mb-2">{{ chat.message }}</p>
              <div class="time text-end">
                <p class="mb-0"><small>{{chat.sentAt}}</small></p>
              </div>
            </div>
          </div>
        </div>

      </div>




      <div *ngIf="paymentsection">
     <div class="text-center text-muted my-5">
      <p class="text-muted">Coming Soon </p>
     </div>

      </div>


    </div>

    <div *ngIf="reasonvisiable">
      <h5 style="margin-left: 15px; margin-top: 15px;">Select Reason for Cancel Booking :</h5>
      <div style="max-height: 450px; overflow-y: auto; background-color: white;; padding-right: 10px;">
        <ng-container *ngFor="let reason of getresonofcancel">
          <div class="form-check mb-2 ms-3">
            <input type="radio" class="form-check-input checkboxsize" [id]="'reason' + reason.cancellationReasonId"
              [name]="'cancelReasonGroup'" (click)="getreasonid(reason.cancellationReasonId, reason.reasonText)" />
            <label class="form-check-label" [for]="'reason' + reason.cancellationReasonId">
              {{ reason.reasonText }}
            </label>
          </div>
        </ng-container>
      </div>




      <div class="row mt-5">
        <div class="col-11">
          <p class="fw-semibold" style="margin-top: 10px;margin-left: 10px;">Rejection Reason (Optional)</p>

        </div>

      </div>

      <div class="position-relative">
        <textarea class="form-control custom-textarea" placeholder="Enter Reason for Cancel Booking..." maxlength="300"
          rows="5"></textarea>
        <div class="char-counter text-muted">
          300
        </div>
      </div>



      <div class="row ">
        <div class="col-11 mt-4">
          <button class="btnapprove" style="width: 95%;margin-left: 2rem;" id="reject"
            (click)=" sendcancelmailtotourguide();sendcancelmailtotourist();cancelbooking();">Cancel Booking</button>
        </div>
      </div>


    </div>
  </div>





</div>